import {Outlet} from "react-router-dom";
import ErrorBoundary from "components/layout/error-boundary";
import Footer from "components/layout/footer";
import Notifications from "components/layout/notifications";
import Navbar from "./navbar";

export default function Container() {
  return (
    <div className="flex flex-col h-screen">
      <Navbar />
      <Notifications />
      <main>
        <ErrorBoundary><Outlet /></ErrorBoundary>
      </main>
      <Footer />
    </div>
  );
}
